import React, { useState } from 'react'
import { Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/react'
import Button from '../../Button/Button'
import { StripeIcon } from '../../../assets/icons'
import * as amplitude from '@amplitude/analytics-browser'

const EmailDistributionStripeModal = ({
  isOpen,
  onClose,
  onConfirm,
  circleCode
}) => {
  const [loading, setLoading] = useState(false)

  const onCancel = () => {
    amplitude.track('Cancelled Payment', {
      event_id: circleCode
    })
    onClose()
  }

  const onSubmit = () => {
    amplitude.track('Checkout Clicked', {
      event_id: circleCode
    })
    setLoading(true)
    onConfirm()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent maxW={'500px'} mx={4} p={0}>
        <ModalBody p={0}>
          <>
            <div className="flex flex-col items-center px-5">
              <StripeIcon width={120} height={60} />
              <p>
                To send your invites, continue to Stripe to complete a secure
                payment.
              </p>
            </div>

            <div className="w-full h-[1px] bg-[#80808033] my-3" />

            <div className="flex flex-col items-center px-2">
              <p className="text-center text-primary text-[20px]">$10</p>

              <span className="px-3 text-primary w-full">
                One-time payment, after which you may send additional emails for
                this event at no extra cost.
              </span>
            </div>

            <div className="w-full h-[1px] bg-[#80808033] my-3" />

            <div className="flex flex-col items-center px-5">
              <p>
                After completing your payment, your invites will be sent, and
                you'll be automatically redirected back to our website.
              </p>
            </div>

            <div className="flex items-center justify-between px-10 my-5">
              <Button
                type={'text'}
                text={'Close'}
                onClick={onCancel}
                size={'small'}
              />
              <Button
                text={'Continue'}
                size={'small'}
                onClick={onSubmit}
                loading={loading}
              />
            </div>
          </>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default EmailDistributionStripeModal
